import get from 'lodash/get';

export const meLoadedFlag = 'meLoaded';

export default function hasData(state) {
  return !!get(state, ['me', 'details', meLoadedFlag]);
}
